import React from "react";

interface FilterGroupProps {
  children: React.ReactNode;
  className?: string;
}

const FilterGroup: React.FC<FilterGroupProps> = ({ children, className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>{children}</div>
);

export default FilterGroup;
